<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>

<fieldset class="evidenceFormField">
    <legend id="iban-edit-title" *ngIf="editMode">{{ 'evidences.form' | translate }} :</legend>
    <legend id="iban-no-edit-title" *ngIf="!editMode">{{ 'evidences.form.sent' | translate }} :</legend>
    <div class="row">
        <div class="two-column-three">
            <label for="input-IBAN_CODE" id="iban-code-label">
                {{ 'evidences.form.IBAN_CODE' | translate }} :
                <input wl-model-iban [readOnly]="!editMode" class="formTextField" name="iban"
                       id="input-IBAN_CODE" type="text" [(ngModel)]="resultData['IBAN_CODE']"
                       maxlength="34" required/>
            </label>
            <div [hidden]="!(form.iban.$dirty && form.iban.$invalid)" role="alert">
                <div [hidden]="!form.iban.$error.required"><span class="fa fa-exclamation-circle" aria-hidden="true"></span> {{
                    'evidences.form.required' | translate }}
                </div>
                <div id="iban-invalid-warn" [hidden]="!form.iban.$error.invalid"><span class="fa fa-exclamation-circle" aria-hidden="true"></span> {{
                    'evidences.form.IBAN_BAD_CHECK' | translate }}
                </div>
            </div>
        </div>
        <div class="one-column-three last-column">
            <label for="input-IBAN_BIC" id="iban-bic-code-label">
                {{ 'evidences.form.IBAN_BIC' | translate }} :
                <input [readOnly]="!editMode" class="formTextField" name="bic"
                       id="input-IBAN_BIC" type="text" [(ngModel)]="resultData['IBAN_BIC']"
                       maxlength="11" required/>
            </label>
            <div [hidden]="!(form.bic.$dirty && form.bic.$invalid)" role="alert">
                <div [hidden]="!form.bic.$error.required">
                    <span class="fa fa-exclamation-circle" aria-hidden="true" id="iban-required-warn"></span>
                    {{ 'evidences.form.required' | translate }}
                </div>
            </div>
        </div>
    </div>
</fieldset>
<div *ngIf="errorMsg" role="alert"><span class="fa fa-exclamation-circle" aria-hidden="true"></span> {{ errorMsg | translate }}</div>